module.exports = __webpack_public_path__ + "static/media/rule.0802762c.svg";